<template>
  <div class="Informations">
    <h2 class="heading-1 Informations__heading" v-html="informationsTitle" />
    <!--<div class="Infotmations__content" v-html="informations" />-->
    <div class="Informations__content">
      <p class="adresse-ip">
        Votre adresse IP : {{ clientIp }}
      </p>
      <div v-html="informations"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      informationsTitle: 'Informations',
      informations: '',
      clientIp: '',
    }
  },
  mounted() {
    if (this.informations === '') {
      this.$api.getContactDetails().then(resp => {
        this.informations = resp.data.data.info.body
        this.informationsTitle = resp.data.data.info.title
      })
    }

    if (this.clientIp === '') {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(response => {
          this.clientIp = response.ip;
        });
    }
  }
}
</script>


<style lang="scss" scoped>
  @import "@/scss/helpers/mixins";
  @import "@/scss/helpers/variables";

  .Informations  {
      min-width: 50%;
      color :var(--unnamed-color-283861);
      text-align :left;
      color: #283861;
      opacity :1;
      padding-left: 5rem;
      @media screen and (max-width:991px) {
        padding: 20px;
      }

      &__content {
        font-family: $campaign;
        font-size: 13px;

        @include min($lg) {
          font-size: 15px;
        }
        ::v-deep {
          p {
            margin: 0 0 5px;
          }
        }
      }
  }

</style>